import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useJoinBoardFromInvite } from '@/hooks/queries/useBoardInviteQuery';
import { canonicalizeBoardInviteSearchParams, getBoardInviteSlug } from '@/lib/boardInviteParams';

export function useBoardInviteJoinFlow(options?: { enabled?: boolean }) {
  const enabled = options?.enabled !== false;
  const [searchParams, setSearchParams] = useSearchParams();
  const boardInviteSlug = enabled ? getBoardInviteSlug(searchParams) : null;
  const { board } = useJoinBoardFromInvite(boardInviteSlug);

  useEffect(() => {
    if (!enabled) return;

    const nextSearchParams = new URLSearchParams(searchParams);
    if (!canonicalizeBoardInviteSearchParams(nextSearchParams, board?.invite_slug)) {
      return;
    }

    setSearchParams(nextSearchParams, { replace: true });
  }, [board?.invite_slug, enabled, searchParams, setSearchParams]);

  return {
    boardInviteSlug,
    joinedBoard: board,
  };
}
